var $sliderMask;

var animateBackground = function () {
  'use strict';

  $('.slider-container h4, .slider-container h5, .slider-container a').removeClass('active');
  $sliderMask.fadeOut(1000);
  setTimeout(function () {
    $sliderMask.fadeIn(0);
    $('.slider-container h4, .slider-container h5').addClass('active');
  }, 1000);
  setTimeout(function () {
    $('.slider-container a').addClass('active');
  }, 1300);
};

$(document).ready(function () {
  'use strict';
  $sliderMask = $('.slider-mask');
  var slider = $('.bxslider').bxSlider({
    mode: 'fade',
    speed: 0,
    onSliderLoad: function () {
      $('.slider-container .tp-loader').hide();
      $('.slider-container .bxslider').css('visibility', 'visible');
      $sliderMask.show();
      animateBackground();
    }
  });

  if (slider) {
    $(document).keydown(function (e) {

      if (e.keyCode === 39) // Right arrow
      {
        slider.goToNextSlide();
        animateBackground();
        return false;
      }
      else if (e.keyCode === 37) // left arrow
      {
        slider.goToPrevSlide();
        animateBackground();
        return false;
      }
    });
  }

});